import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { apiCall } from "services/api";

import { toFormData } from "utils/files";

import { CompanyForm } from "./types";

export const updateCompany = createAsyncThunk(
  "/company/update",
  async ({ values }: { values: CompanyForm }, { rejectWithValue }) => {
    try {
      const formdata = toFormData(values);
      const response = await apiCall().post("/company/update", formdata);
      toast.success("Company data updated");
      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const getCompany = createAsyncThunk(
  "/company",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall({}).get("/company");

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const getCompanyTypes = createAsyncThunk(
  "/company/type",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall({}).get(
        "/enums/single?enum=Domain\\Company\\Enums\\CompanyTypes"
      );

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
